(function () {
    'use strict';

    angular.module("imApp").factory("orderLineCancelCausesService", ['$ihttp', function ($ihttp) {
        let service = {
            listOrderLineCancelCauses: function (parms) {
                return $ihttp.post({
                    method: 3328,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
